"use strict";
/**
 * @module Services.FetchJMXValues
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var jmx_fetch_request_1 = require("./jmx-fetch-request");
/**
 * Serialiser for {@link JMXFetchRequest}
 */
var JMXFetchRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(JMXFetchRequestSerialiserClass, _super);
    function JMXFetchRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link JMXFetchRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link JMXFetchRequest} that was read
     */
    JMXFetchRequestSerialiserClass.prototype.read = function (bis) {
        var names = Codec.readCollection(bis, Codec.readString);
        var isClustered = Codec.readBoolean(bis);
        return new jmx_fetch_request_1.JMXFetchRequest(names, isClustered);
    };
    /**
     * Write a {@link JMXFetchRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link JMXFetchRequest} to be written
     */
    JMXFetchRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeCollection(bos, value.names, Codec.writeString);
        Codec.writeBoolean(bos, value.isClustered);
    };
    return JMXFetchRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.JMXFetchRequestSerialiserClass = JMXFetchRequestSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.JMXFetchRequestSerialiser = new JMXFetchRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/fetch-jmx-values/jmx-fetch-request-serialiser.js
// module id = 1362
// module chunks = 0